import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import axiosInstance from "../../Api/axiosInstance"

export const getAllPriceBook = async(params={})=>{
   let response = await axiosInstance.get(API_ENDPOINTS.PRICE_BOOK.GET_ALLPRICEBOOK,{
         params:{...params}
   });
   return  response?.data;
}

interface ReqBody {
        PriceBookName:string,
        orgUnitId:number,
        description:string
}

export const addPriceBook = async({ReqBody}:{ReqBody:ReqBody})=>{
    const url  = `${API_ENDPOINTS.PRICE_BOOK.POST_ADD_PRICEBOOK}` 

    let response = await axiosInstance.post(url,ReqBody);
    return  response?.data; 
}

export const updatePriceBook = async({ReqBody,id}:{ReqBody:any,id:number})=>{

    const url = `${API_ENDPOINTS.PRICE_BOOK.PUT_UPDATE_PRICEBOOK}/${id}`
    let response = await axiosInstance.put(url,ReqBody);
    return response?.data;
}

export const getAllPriceBookList = async (id: number, page:number, limit:number, search?:string, brand_id?:number | string, category_id?:number | string) => {
    const response = await axiosInstance.get(
      `${API_ENDPOINTS.PRICE_BOOK.GET_PRICEBOOK_LIST}/${id}`, 
      {
        params: {
          page,
          limit,
          search,
          brand_id,
          category_id
        }
      }
    );
    return response?.data;
  }
  
  
export const savePriceBookLine = async ({ReqBody,id}:{ReqBody:any,id:number})=>{

    const url = `${API_ENDPOINTS.PRICE_BOOK.POST_SAVE_PRICEbOOK_LINES}/${id}`
    let response = await axiosInstance.post(url,ReqBody);
    return response?.data;
}